import { QuestionBase } from './question-base';

export class DropdownQuestion extends QuestionBase<string> {
  controlType = 'dropdown';
  options: { key: string; value: string }[] = [];
  okText?: string;
  cancelText?: string;
  defaultValue?: number;

  constructor(options: any = {}) {
    super(options);
    this.options = options['options'] || [];
    this.okText = options['okText'] || 'OK';
    this.cancelText = options['cancelText'] || 'CANCEL';
    this.defaultValue = options['defaultValue'] || undefined;
  }
}
